import { getToken } from './local-storage';
// eslint-disable-next-line import/prefer-default-export
export function getHeaders() {
    return { Authorization: getToken() };
}
